import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { fetchPersonalDetails } from 'lib/actions';
import {
    getPersonalDetails,
    getPersonalDetailsIsFetching,
    getPersonalDetailsError,
} from 'lib/selectors';
import { MORE, MORE_EDIT_PERSONAL_DETAILS } from 'constants/shared/routes';
import PersonalDetails from '../presentational/PersonalDetails';
import DataCheck from 'components/shared/generic/dataCheck/presentational/DataCheck';
import PageContainer from 'components/shared/generic/pageContainer/presentational/PageContainer';
import SectionTitle from 'components/shared/generic/sectionTitle/presentational/SectionTitle';
import useTranslate from 'lib/languages/useTranslate';
import { IPersonalDetails, PersonalDetailSection } from 'lib/type';

const PersonalDetailsContainer = () => {
    const dispatch = useDispatch();
    const history = useHistory();
    const details = useSelector(getPersonalDetails) as IPersonalDetails;
    const isFetching = useSelector(getPersonalDetailsIsFetching) as boolean;
    const error = useSelector(getPersonalDetailsError) as string;
    const translate = useTranslate('personalDetails');

    const handleEditClick = (editPart: PersonalDetailSection) => {
        history.push(MORE_EDIT_PERSONAL_DETAILS, { editPart })
    };

    useEffect(() => {
        dispatch(fetchPersonalDetails());
        //eslint-disable-next-line
    }, []);

    return (
        <PageContainer className="more-personal-details-container">
            <SectionTitle title={translate('titleText')} backRoute={MORE} />
            <DataCheck
                data={details}
                isLoading={isFetching}
                error={error}
                noDataMessage={translate('noDataMessage')}
            >
                <PersonalDetails
                    data={details}
                    editClick={(editPart: PersonalDetailSection) => handleEditClick(editPart)}
                />
            </DataCheck>
        </PageContainer>
    );
};

export default PersonalDetailsContainer;
